
import { Component, Vue } from 'vue-property-decorator';
import LayoutDefault from '@/layouts/LayoutDefault.vue';
import OrderOverview from '@/components/orders/OrderOverview.vue';
import MfaWarning from '@/components/authentication/MfaWarning.vue';

@Component({
  components: { LayoutDefault, OrderOverview, MfaWarning },
})
export default class MyOrders extends Vue {
  get hasMfa(): boolean {
    return this.$store.getters['auth/hasMfa'];
  }
}
